import { Checkbox, Combobox } from '@mantine/core';
import * as React from 'react';

import { OptionEntity } from 'types/OptionEntity';

import s from './CheckboxOption.module.scss';

type Props = {
  option: OptionEntity;
  checked: boolean;
};

const CheckboxOption: React.FC<Props> = ({ option, checked }) => (
  <Combobox.Option className={s.root} value={option.key} selected={checked}>
    <Checkbox.Indicator className={s.root__indicator} checked={checked} radius={4} />
    {option.value}
  </Combobox.Option>
);

export default React.memo(CheckboxOption);
